import { Box } from "@mui/material";
import PensionRatesForm from "./form";
import { HRService } from "../../../../config";
import { AllPensionRatesColumns } from "../../../../data/Columns/hrmanagement";
import { allPensionRates } from "../../../../data/Queries/HRmanagement/leavemanagement";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";

const base_url = HRService.uri;
const actions = {
  entity: "Pension Rate",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  markTask: {
    key: "MARK_TASK_DONE",
    button_name: "Mark Task Done",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  showStatus: true,
};

function PensionRatesTable() {
  return (
    <Box m="2px"> 
      <DynamicTable
        title="Pension Rates"
        subtitle="View all pension rates, create and edit"
        columns={AllPensionRatesColumns}
        FormComponent={PensionRatesForm}
        actions={actions}
        query={allPensionRates}
        base_url={base_url}
      />
    </Box>
  );
}

export default PensionRatesTable;